import styled from "styled-components";

export const DocUploadWrapper = styled.div`
  .additional-form-title {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    margin-bottom: 1em;
  }

  .file-inputs {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  .file-inputs label {
    font-size: 16px;
  }

  .file-input-box {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .file-input-box input[type="file"] {
    padding: 10px;
    font-size: 14px;
    margin-top: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .clear-icon {
    color: #cb3443;
    line-height: 0px;
    font-size: 50px;
  }

  .error {
    color: #cb3443;
    font-size: 12px;
    margin-top: 5px;
  }

  .bottomDiv {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
    flex-direction: row;
  }

  .salary-slip-contain {
    border: 2px solid rgb(153, 153, 153);
    border-radius: 10px;
    margin-bottom: 25px;
    padding: 0.5em 1em;
  }

  .salary-slip-contain + div {
    margin-bottom: 20px;
  }

  .salary-slip-contain .main-container-doc-input {
    margin: 0.5em 0px 1em;
  }

  .salary-slip-contain .main-container-doc-input p {
    margin-bottom: 0;
    line-height: 90%;
  }

  .salary-slip-contain .main-container-doc-input span > p:first-child {
    font-size: 1.5em;
  }

  .salary-slip-contain .main-container-doc-input span > p:last-child {
    color: var(--gray);
  }

  .salary-slip-contain .main-container-doc-input span > img {
    height: 2em;
  }

  .salary-slip-contain .main-container-doc-input div + span {
    display: flex;
    align-items: center;
  }

  .salary-slip-contain .main-container-doc-input div {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  .docpass-input .floating-input {
    margin-top: 60px;
  }

  .docpass-input label {
    width: 100%;
    top: -1.5em !important;
  }
`;
